import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TotalCatchesV2MobileItemModel } from 'src/app/services/visit.service';

@Component({
  selector: 'app-total-catches-dialog',
  templateUrl: './total-catches-dialog.component.html',
  styleUrls: ['./total-catches-dialog.component.scss'],
})
export class TotalCatchesDialogComponent {
  public totalCatches: number;
  public catches: TotalCatchesV2MobileItemModel[];

  constructor(
    public dialogRef: MatDialogRef<TotalCatchesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.totalCatches = data.totalCatches || 0;
    this.catches = data.catches || [];
    dialogRef.disableClose = false;
  }

  public close(): void {
    this.dialogRef.close();
  }
}
